import { updateField } from '../helpers'
import { CustomersService } from '@common/ApiService'
import paginationHeaders from '@/src/utils/pagination-headers'

const CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS'
const CUSTOMER_SEARCH_SUCCESS = 'CUSTOMER_SEARCH_SUCCESS'
const UPDATE_PAGINATION = 'UPDATE_PAGINATION'
const CUSTOMER_ERROR = 'CUSTOMER_ERROR'
const CUSTOMER_PROGRESS = 'CUSTOMER_PROGRESS'
const CUSTOMER_CLEAR = 'CUSTOMER_CLEAR'
const CUSTOMER_SET = 'CUSTOMER_SET'
const SEARCH_CLEAR = 'SEARCH_CLEAR'
const UPDATE_ASSISTANCE_ADDITIONAL_INFO = 'updateAssistanceAdditionalInfo'

export const state = {
  search_result: [],
  pagination: {},
  customer: {
    ref: null,
    title: 'Empty',
    first_name: '',
    last_name: '',
    phone: '',
    email: null,
    postcode: '',
    address: '',
    companion_name: '',
    companion_phone: '',
    general_notes: '',
    follow_up_consent: '',
    follow_up_consent_at: '',
    assistances: [],
    railcard_type: null,
    preferred_method_of_contact: 'none',
  },
  errors: {},
  progress: '',
  forceRecompute: 0,
}

export const mutations = {
  updateField,

  [CUSTOMER_SEARCH_SUCCESS](state, data) {
    state.search_result = data
    return state
  },

  [CUSTOMER_SUCCESS](state, data) {
    state.errors = {}
    state.customer = data
    return state
  },

  [UPDATE_PAGINATION](state, response) {
    state.pagination = paginationHeaders(response)
    return state
  },

  [CUSTOMER_SET](state, index) {
    const oldCustomer = state.customer
    const newCustomer = state.search_result[index]

    if (oldCustomer.ref !== newCustomer.ref)
      localStorage.removeItem('Assistance_List')
    if (!newCustomer.assistances) newCustomer.assistances = []

    Object.assign(oldCustomer, newCustomer)
    return state
  },

  [CUSTOMER_PROGRESS](state, progress) {
    state.progress = progress
    return state.progress
  },

  [CUSTOMER_ERROR](state, data) {
    state.errors = data
    return state
  },

  [SEARCH_CLEAR](state) {
    state.search_result = []
  },

  [CUSTOMER_CLEAR](state) {
    state.customer.ref = null
    state.customer.title = 'Empty'
    state.customer.first_name = ''
    state.customer.last_name = ''
    state.customer.phone = ''
    state.customer.email = null
    state.customer.postcode = ''
    state.customer.address = ''
    state.customer.companion_name = ''
    state.customer.companion_phone = ''
    state.customer.general_notes = ''
    state.customer.follow_up_consent = ''
    state.customer.follow_up_consent_at = ''
    state.customer.assistances = []
    state.customer.railcard_type = null
    state.customer.preferred_method_of_contact = 'none'
    state.search_result = []
    return state
  },

  [UPDATE_ASSISTANCE_ADDITIONAL_INFO](
    state,
    { selectedOption, key, property }
  ) {
    state.customer.assistances.map((item) => {
      if (item.key === key) {
        if (item['additional_info'] === undefined) item['additional_info'] = {}
        item['additional_info'][property] = selectedOption
      }
    })

    state.forceRecompute++
  },
}

export const actions = {
  createCustomer({ commit }, newCustomer) {
    return CustomersService.create({
      ...newCustomer,
    })
      .then((response) => {
        commit(CUSTOMER_SUCCESS, response.data)
        commit(CUSTOMER_PROGRESS, 'success')
      })
      .catch((error) => {
        commit(CUSTOMER_ERROR, error)
        commit(CUSTOMER_PROGRESS, 'error')
      })
  },

  updateCustomer({ commit }, customer) {
    return CustomersService.update(customer.ref, {
      ...customer,
    })
      .then((response) => {
        commit(CUSTOMER_SUCCESS, response.data)
        commit(CUSTOMER_PROGRESS, 'success')
      })
      .catch((error) => {
        commit(CUSTOMER_ERROR, error)
        commit(CUSTOMER_PROGRESS, 'error')
      })
  },

  deleteCustomer({ commit }, customerRef) {
    return CustomersService.destroy(customerRef).then((response) => {
      commit(CUSTOMER_CLEAR)
      commit(SEARCH_CLEAR)
    })
  },

  useCustomer({ commit }, index) {
    commit(CUSTOMER_PROGRESS, 'customer_set')
    commit(CUSTOMER_SET, index)
  },

  fetchCustomer({ commit }, query) {
    commit(CUSTOMER_PROGRESS, 'search_loading')
    return CustomersService.search(query)
      .then((response) => {
        commit(CUSTOMER_SEARCH_SUCCESS, response.data)
        commit(UPDATE_PAGINATION, response)
        commit(CUSTOMER_PROGRESS, 'customer_success')
      })
      .catch((error) => {
        commit(CUSTOMER_ERROR, error)
        commit(CUSTOMER_PROGRESS, 'error')
      })
  },

  setCustomer({ commit }, payload) {
    commit(CUSTOMER_SEARCH_SUCCESS, [payload])
    commit(CUSTOMER_SET, 0)
  },

  clearCustomer({ commit }) {
    commit(CUSTOMER_CLEAR)
  },

  clearSearch({ commit }) {
    commit(SEARCH_CLEAR)
  },
}
